var _path, _rect, _path2, _path3, _ellipse, _ellipse2, _path4, _path5, _path6, _path7, _rect2, _rect3, _rect4, _rect5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRacklogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 33,
    viewBox: "0 0 102 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9012 25.084V8.99183H38.522C39.9473 8.99183 41.1657 9.22172 42.1772 9.68149C43.204 10.1413 43.9933 10.8003 44.545 11.6585C45.0967 12.5168 45.3726 13.5359 45.3726 14.716C45.3726 15.8961 45.0967 16.9153 44.545 17.7735C43.9933 18.6165 43.204 19.2678 42.1772 19.7276C41.1657 20.172 39.9473 20.3943 38.522 20.3943H33.5564L34.8897 19.0379V25.084H31.9012ZM42.43 25.084L38.361 19.2448H41.5565L45.6485 25.084H42.43ZM34.8897 19.3598L33.5564 17.9345H38.384C39.702 17.9345 40.6906 17.6509 41.3496 17.0839C42.0239 16.5168 42.3611 15.7275 42.3611 14.716C42.3611 13.6892 42.0239 12.8999 41.3496 12.3482C40.6906 11.7965 39.702 11.5206 38.384 11.5206H33.5564L34.8897 10.0493V19.3598ZM46.2104 25.084L53.4519 8.99183H56.3945L63.6589 25.084H60.5325L54.3025 10.5781H55.4979L49.2909 25.084H46.2104ZM49.5438 21.3598L50.3484 19.0149H59.0382L59.8428 21.3598H49.5438ZM65.4756 25.084V8.99183H67.9354L74.97 20.7391H73.6826L80.6022 8.99183H83.062L83.085 25.084H80.2574L80.2344 13.4287H80.8321L74.947 23.2449H73.6136L67.6365 13.4287H68.3262V25.084H65.4756ZM92.1904 25.3139C90.9336 25.3139 89.7306 25.1376 88.5811 24.7851C87.4317 24.4173 86.5198 23.9499 85.8455 23.3828L86.88 21.0609C87.5236 21.5667 88.3206 21.9882 89.2708 22.3253C90.221 22.6625 91.1942 22.8311 92.1904 22.8311C93.0333 22.8311 93.7153 22.7391 94.2364 22.5552C94.7574 22.3713 95.1406 22.1261 95.3858 21.8196C95.631 21.4977 95.7536 21.1376 95.7536 20.7391C95.7536 20.2487 95.5774 19.8579 95.2249 19.5667C94.8724 19.2602 94.4126 19.0226 93.8456 18.854C93.2938 18.6701 92.6731 18.5015 91.9835 18.3483C91.3091 18.195 90.6271 18.0188 89.9375 17.8195C89.2631 17.605 88.6424 17.3368 88.0754 17.0149C87.5236 16.6777 87.0715 16.2333 86.719 15.6816C86.3665 15.1298 86.1903 14.4248 86.1903 13.5666C86.1903 12.693 86.4202 11.8961 86.88 11.1758C87.3551 10.4401 88.0677 9.85774 89.0179 9.42862C89.9834 8.98417 91.2018 8.76194 92.6731 8.76194C93.6387 8.76194 94.5965 8.88455 95.5467 9.12976C96.4969 9.37498 97.3245 9.72747 98.0295 10.1872L97.087 12.5091C96.3667 12.08 95.6234 11.7658 94.8571 11.5666C94.0908 11.352 93.3551 11.2447 92.6501 11.2447C91.8225 11.2447 91.1482 11.3443 90.6271 11.5436C90.1214 11.7428 89.7459 12.0034 89.5007 12.3252C89.2708 12.647 89.1558 13.0149 89.1558 13.4287C89.1558 13.9191 89.3244 14.3176 89.6616 14.6241C90.0141 14.9153 90.4662 15.1452 91.0179 15.3137C91.585 15.4823 92.2134 15.6509 92.903 15.8195C93.5927 15.9728 94.2747 16.149 94.949 16.3482C95.6387 16.5475 96.2594 16.808 96.8111 17.1299C97.3782 17.4517 97.8303 17.8885 98.1674 18.4402C98.5199 18.992 98.6962 19.6893 98.6962 20.5322C98.6962 21.3905 98.4586 22.1874 97.9835 22.923C97.5238 23.6434 96.8111 24.2257 95.8456 24.6702C94.8801 25.0993 93.6616 25.3139 92.1904 25.3139Z",
    fill: "url(#paint0_linear_7173_230821)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.931641,
    y: 2.69775,
    width: 26.7759,
    height: 26.7759,
    rx: 2.24447,
    fill: "url(#paint1_linear_7173_230821)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8105 7.77246V24.0154",
    stroke: "white",
    strokeWidth: 1.23965
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82812 7.77051V24.0135",
    stroke: "white",
    strokeWidth: 1.23965
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.82894,
    cy: 7.57086,
    rx: 0.741045,
    ry: 0.727601,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.8055,
    cy: 7.57086,
    rx: 0.741045,
    ry: 0.727601,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82812 13.5454H21.3574",
    stroke: "white",
    strokeWidth: 1.23965
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27539 19.8857H21.8046",
    stroke: "white",
    strokeWidth: 1.23965
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91016 25.1171C4.91016 24.5085 5.4035 24.0151 6.01207 24.0151H7.64831C8.25688 24.0151 8.75023 24.5085 8.75023 25.1171V25.3286H4.91016V25.1171Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8887 25.1171C19.8887 24.5085 20.382 24.0151 20.9906 24.0151H22.6268C23.2354 24.0151 23.7287 24.5085 23.7287 25.1171V25.3286H19.8887V25.1171Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.36523,
    y: 15.894,
    width: 4.08781,
    height: 3.05329,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.36523,
    y: 9.30078,
    width: 4.08781,
    height: 3.05329,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7988,
    y: 15.894,
    width: 4.08781,
    height: 3.05329,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7988,
    y: 9.30078,
    width: 4.08781,
    height: 3.05329,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7173_230821",
    x1: 39.7515,
    y1: 6.66617,
    x2: 102.309,
    y2: 21.4764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2257BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63D4EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7173_230821",
    x1: -2.17638,
    y1: 2.69775,
    x2: 39.4685,
    y2: 37.6094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B2CEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.530199,
    stopColor: "#20BDFF",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971875,
    stopColor: "#A5FECB",
    stopOpacity: 0.82
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRacklogo);
export default __webpack_public_path__ + "static/media/Racklogo.ff209d089ac125a43bfececebad86b03.svg";
export { ForwardRef as ReactComponent };